import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@ublique/components/LoadingModal'
import ReactMarkdown from 'react-markdown'
import Tabs from '@ublique/components/Tabs'
import Dropdown from '@ublique/components/Dropdown'

import './modal.scss'

const ModalChangelog = ({
  open,
  close,
  data: { libraryName, libraryVersion, urlChangelog }
}) => {
  const { t } = useTranslation(['Common', 'Shell'])
  const [loading, setLoading] = useState(false)
  const [versionsList, setVersionsList] = useState('')
  const [selectedVersion, setSelectedVersion] = useState('')

  useEffect(() => {
    setLoading(true)
    const changelogText = () => {
      return new Promise((resolve) => {
        fetch(urlChangelog)
          .then((response) => response.text())
          .then((text) => {
            resolve(text)
            setLoading(false)
          })
      })
    }

    changelogText().then((res) => {
      libraryVersion = libraryVersion.split('-snapshot')[0]

      const responseSplit = res
        .replace(/# Changelog/g, '')
        .split(/(?=^##\W*[0-9].[0-9].[0-9])/gm)

      const versions = []

      responseSplit.forEach((element) => {
        const splitRegText = '(?=^##\\W*' + ')'
        const reg = new RegExp(splitRegText, 'gm')
        var matches = element.split(reg)[0].match(/\[(.*?)\]/)
        if (matches) {
          const submatch = matches[1]
          if (submatch !== 'standard-version') {
            versions.push({
              title:
                submatch === libraryVersion
                  ? `${submatch} - ${t('LATEST_VERSION')}`
                  : submatch,
              body: element
            })
          }
        }
      })

      setVersionsList(versions)
      setSelectedVersion(versions[0])
    })
  }, [urlChangelog])

  const renderMainContent = () => (
    <div className='tab-content'>
      <div className='versions-dropdown-wrapper'>
        <Dropdown
          className='versions-dropdown'
          titleText={t('Versions')}
          selectedItem={selectedVersion}
          items={versionsList}
          itemToString={({ title }) => title}
          onChange={({ selectedItem }) => setSelectedVersion(selectedItem)}
        />
      </div>
      {selectedVersion && (
        <ReactMarkdown>{selectedVersion?.body}</ReactMarkdown>
      )}
    </div>
  )

  return (
    <Modal
      open={open}
      onRequestClose={close}
      modalHeading={libraryName + ' ' + libraryVersion}
      className='changelog'
      loading={loading}
      confirmLoadingMessage={t('Common:Submitting')}
      passiveModal
      size='md'
      preventCloseOnClickOutside
    >
      <div className='content-modal'>{renderMainContent()}</div>
    </Modal>
  )
}

export default ModalChangelog
